export function throttle(func: Function, delay?: number) {
	let lastExec = 0;
	let queueTimer: number | void;
	
	function wrapper() {
		var that = this;
		var elapsed = +new Date() - lastExec;
		var args = arguments;
	
		function exec() {
			lastExec = +new Date();
			if (queueTimer) {
				queueTimer = clearTimeout(queueTimer);
			}
			func.apply(that, args);
		};
		
		if (elapsed > delay) {
			exec();
		} else {
			if (!queueTimer) {
				queueTimer = window.setTimeout(exec, delay-elapsed);
			}
		}
	};

  return wrapper;
};
